<div class="row">
    <div class="col-48 position-relative" [style.height.px]="height">
        <div *ngIf="areAllDataRowsEmpty() && emptyDataMessage.length > 0 && getDataComplete"
             class="charts-overlay">
            <span class="charts-overlay-text">
                {{ emptyDataMessage }}
            </span>
        </div>
        <canvas [attr.height]="height"
                class="chart-line"
                *ngIf="!areAllDataRowsEmpty()"
                chartBase
                [chartType]="'line'"
                [chartData]="data"
                [chartLabels]="labels"
                [chartSeries]="series"
                [chartOptions]="options"
                [chartDatasetOverride]="override"
                [chartColors]="colors">
        </canvas>
    </div>
</div>
